<script setup lang="ts">
import {onBeforeMount, PropType, Ref, ref} from "vue";


const props = defineProps({
	modelValue: {
		type: Object as PropType<App.Data.Explorer.Filter.FilterValueDTO[]>,
		require: true,
	}
});

const emit = defineEmits(["update:modelValue"]);

onBeforeMount(() => {
	localModelValue.value = props.modelValue || [];
})

const emitChange = () => {
	emit("update:modelValue", localModelValue.value);
}

const localModelValue: Ref<App.Data.Explorer.Filter.FilterValueDTO[]> = ref(null);

// DO NOT touch the id's they are used as input for the query
const DaysOfWeek = [
	{id: 1, level: null, selection_depth: null, model: null, label: 'Monday'},
	{id: 2, level: null, selection_depth: null, model: null, label: 'Tuesday'},
	{id: 3, level: null, selection_depth: null, model: null, label: 'Wednesday'},
	{id: 4, level: null, selection_depth: null, model: null, label: 'Thursday'},
	{id: 5, level: null, selection_depth: null, model: null, label: 'Friday'},
	{id: 6, level: null, selection_depth: null, model: null, label: 'Saturday'},
	{id: 7, level: null, selection_depth: null, model: null, label: 'Sunday'},
];
</script>

<template>
	<v-autocomplete
		placeholder="Select a Value"
		:items="DaysOfWeek"
		item-title="label"
		item-value="id"
		multiple
		return-object
		:clearable="true"
		v-model="localModelValue"
		@update:modelValue="emitChange()"
	/>
</template>

<style lang="scss" scoped></style>
